export function shareToWeibo(row) {
    console.log(row,'分享微博');
    const url = encodeURIComponent(window.location.href); // 当前页面的URL
    let title
    if(row.title){
        title = row.title
    }else if(row.name){
        title = row.name
    }else if(row.trainName){
        title = row.trainName
    }else if(row.organizationName){
        title = row.organizationName
    }
    const shareUrl = `https://service.weibo.com/share/share.php?url=${url}&title=${title}`;
    return window.open(shareUrl);
}